import { fetchDismissThirdPartyAccount } from "@/app/csr-src/apis/profile/profile.api";
import TipsCloseSvg from "@/assets/icons/TipsClose.svg";
import WarningSvg from "@/assets/icons/Warning.svg";
import SafeLink from "@/components/SafeLink";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";
// 埋点
import { EXPOSURE_RECORD, sendClickTrack } from "@/tracks/31803";

interface LinkTipsProps {
  linkThirdUrl: string;
}

const LinkTips: React.FC<LinkTipsProps> = ({ linkThirdUrl }) => {
  const { t } = useTranslation();
  const [isShowLinkTips, setIsShowLinkTips] = useState<boolean>(true); // 关闭关联账号提示
  // 关闭管理账号绑定提示
  const handleDismiss = async () => {
    sendClickTrack.Bind_Ochama_Card_Dismiss_Button_Click();
    await fetchDismissThirdPartyAccount({ type: 1 });
    setIsShowLinkTips(false);
  };

  // 点击埋点
  const handleLinkTrack = () => {
    sendClickTrack.Bind_Ochama_Card_Link_Button_Click()
  }

  if (isShowLinkTips && linkThirdUrl) {
    return (
      <div
        className={styles.linkTips}
        exptag={"exp|" + EXPOSURE_RECORD.Bind_ochama_card_Exp}
        data-exptag-config={JSON.stringify({
          useClick: false,
          stay_duration: 0.3,
          repeated: false,
          area_rate: 0.5,
        })}
      >
        <div className={styles.inner}>
          <div className={styles.tips}>
            <WarningSvg style={{ marginRight: "6px" }} />
            {t("profile.page.linkTips")}
          </div>
          <div className={styles.link}>
            <SafeLink href={linkThirdUrl}>
              <div
                className={styles.linkBtn}
                exptag={"exp|" + EXPOSURE_RECORD.Bind_Ochama_Link_Button_Exp}
                data-exptag-config={JSON.stringify({
                  useClick: false,
                  stay_duration: 0.3,
                  repeated: false,
                  area_rate: 0.5,
                })}
                onClick={handleLinkTrack}
              >
                {t("profile.page.linkBtn")}
              </div>
            </SafeLink>
            <TipsCloseSvg
             style={{ marginLeft: "10px" }} 
             onClick={handleDismiss} 
             exptag={"exp|" + EXPOSURE_RECORD.Bind_Ochama_Card_Dismiss_button_Exp}
             data-exptag-config={JSON.stringify({
               useClick: false,
               stay_duration: 0.3,
               repeated: false,
               area_rate: 0.5,
             })}
            />
          </div>
        </div>
      </div>
    );
  }
};

export default LinkTips;
